import { TypographyVariant } from 'libs/ui/theme/typography';

import { ChipVariant } from '../types';

export const typographyVariant: Record<ChipVariant, TypographyVariant> = {
  standard: 'bodySemiBold',
  medium: 'captionMedium',
  small: 'captionSemiBold',
};
